import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";

/**
 * Generated class for the WebfleetChooseWorkPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-webfleet-choose-work',
  templateUrl: 'webfleet-choose-work.html',
})
export class WebfleetChooseWorkPage {
  costcenters: any = [];
  allCostcenters: any = [];
  isChange: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {
    this.isChange = this.navParams.get('isChange');
  }
  ionViewDidEnter() {
    this.loadCostcenters();
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad WebfleetChooseWorkPage');
  }

  timeNow() {
    return new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  }

  loadCostcenters() {
    this.teamappProvider.http_request('action=get_cost_centers', 'webfleet', false).then(data => {
      this.costcenters = data;
      this.allCostcenters = data;
      console.log(data);
    });
  }

  chooseCostcenter(costcenter: any) {
    if(this.isChange == true) {
      this.teamappProvider.http_request('action=change_costcenter&costcenter='+costcenter.inner, 'webfleet', false).then(data => {
        this.navCtrl.pop();
      });
    } else {
      this.teamappProvider.http_request('action=start_work&costcenter='+costcenter.inner, 'webfleet', false).then(data => {
        this.userProvider.setUserStatus('<div class="workstate working">Arbeitet</div> seit '+this.timeNow());
        this.navCtrl.pop();

      });
    }

  }

  initializeItems() {
    this.costcenters = this.allCostcenters;
  }
  getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.costcenters = this.allCostcenters.filter(item => {
        return item.name.toLowerCase()
            .indexOf(val.toLowerCase()) > -1;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/webfleet-choose-work/webfleet-choose-work.ts